import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigProvider } from 'antd';
import { useLocale } from 'hooks/use-language-select';
import { getAntdLocale } from './antd-locale';
export const AntdLocaleProvider = ({ children, ...configProps })=>{
    const { locale } = useLocale();
    const antdLocale = getAntdLocale(locale || 'en');
    return /*#__PURE__*/ _jsx(ConfigProvider, {
        locale: antdLocale,
        ...configProps,
        children: children
    });
};
